'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
export const ratingClassNames = {
  root: 'fui-Rating'
};
/**
 * Styles for the root slot
 */
const useRootClassName = /*#__PURE__*/__resetStyles("r2imjyh", null, [".r2imjyh{display:flex;flex-wrap:wrap;}"]);
/**
 * Apply styling to the Rating slots based on the state
 */
export const useRatingStyles_unstable = state => {
  const rootClassName = useRootClassName();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(ratingClassNames.root, rootClassName, state.root.className);
  return state;
};